import { filterClasses } from "@swivl-mono/helpers";
import { forwardRef, useId } from "react";

import { ErrorText } from "../FormField/FormField.ErrorText";
import { HelperText } from "../FormField/FormField.HelperText";
import { getFormFieldWidthClass } from "../FormField/FormField.Helpers";
import { Label } from "../FormField/FormField.Label";
import { FormFieldWidth } from "../FormField/FormField.Types";
import { TextAreaField } from "./TextArea.Field";
import type { TextAreaProps } from "./TextArea.Field";

export interface TextAreaInputProps extends Omit<TextAreaProps, "error"> {
  label?: string;
  helperText?: string;
  error?: string;
  containerClassName?: string;
  width?: FormFieldWidth;
  required?: boolean;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaInputProps>(
  ({ label, helperText, error, containerClassName, required, id, width = FormFieldWidth.FULL, ...props }, ref) => {
    const generatedId = useId();
    const inputId = id || generatedId;
    const containerWidthClass = getFormFieldWidthClass(width);
    const resolvedContainerClassName = filterClasses(containerWidthClass, containerClassName);

    return (
      <div className={resolvedContainerClassName}>
        {label && (
          <Label htmlFor={inputId} required={required} className="mb-1">
            {label}
          </Label>
        )}
        <TextAreaField ref={ref} id={inputId} error={!!error} {...props} />
        {error && <ErrorText>{error}</ErrorText>}
        {!error && helperText && <HelperText>{helperText}</HelperText>}
      </div>
    );
  }
);

TextArea.displayName = "TextArea";
